/**
 * 受注変更履歴
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

const manifest_change_history = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @return {Promise<unknown>}
     */
    index ({ commit }, { manifest_id, params }) {
      const api_path = `${API_PATH}/${manifest_id}/manifest_change_histories`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default manifest_change_history

